// extracted by mini-css-extract-plugin
export var date = "recent-news-section-module--date--o3qLw";
export var recentNewsContainer = "recent-news-section-module--recent-news-container--I2SOO";
export var singleRecentNews = "recent-news-section-module--single-recent-news--Mm7DF";